module.exports = __webpack_public_path__ + "img/troy.3a14bde.png";